module.exports = __webpack_public_path__ + "static/day09-6e17c90cf325c961a7515de25608e8b2.png";